export enum PublishedDocumentMetadataMigrationStatus {
  Pending = 0,
  Running = 1,
  Completed = 2,
  Failed = 3,
  Cancelled = 4,
  CompletedWithExceptions = 5,
  Cancelling = 6,
}

export interface PublishedDocumentMetadataMigrationStartRequest {
  resumeJobId?: string;
  retryExceptions?: boolean;
}

export interface PublishedDocumentMetadataMigrationWorkerStatus {
  workerEnabled?: boolean;
}

export interface PublishedDocumentMetadataMigrationCounters {
  scanned: number;
  updated: number;
  skipped: number;
  fileMissing: number;
  ambiguous: number;
  exceptions: number;
  conflicts: number;
}

export interface PublishedDocumentMetadataMigrationJob {
  id: string;
  status: PublishedDocumentMetadataMigrationStatus;
  createdAtUtc?: string;
  startTime: string;
  endTime?: string;
  heartbeatAtUtc?: string;
  triggeredByUserId?: string;
  continuationToken?: string;
  pageNumber: number;
  cancellationRequested: boolean;
  errorMessage?: string;
  canResume: boolean;
  canRetryExceptions: boolean;
  migrationCounters?: PublishedDocumentMetadataMigrationCounters;
}

export function isMigrationActive(
  status?: PublishedDocumentMetadataMigrationStatus
) {
  return (
    status === PublishedDocumentMetadataMigrationStatus.Pending ||
    status === PublishedDocumentMetadataMigrationStatus.Running ||
    status === PublishedDocumentMetadataMigrationStatus.Cancelling
  );
}
